import { Box, Button, Typography } from "@mui/material";
import MainLayout from "layouts/Main";
import { isRouteErrorResponse, Link, useRouteError } from "react-router-dom";
import NotFound from "views/NotFound";

const RouteError = () => {
  const error = useRouteError();

  if (isRouteErrorResponse(error) && error.status === 404) {
    return <NotFound />;
  }

  return (
    <MainLayout>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          mt: "4rem",
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom>
          Something went wrong
        </Typography>
        <Typography variant="h6" component="p" gutterBottom>
          An unexpected error occurred. Please try again or return to the home
          page.
        </Typography>
        <Box sx={{ mt: "1rem", display: "flex", gap: "1rem" }}>
          <Button variant="outlined" onClick={() => window.location.reload()}>
            Reload
          </Button>
          <Button component={Link} to="/" variant="contained">
            Go to home page
          </Button>
        </Box>
      </Box>
    </MainLayout>
  );
};

export default RouteError;
